exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/slider/slider.component.css
// module id = ../../../../../src/app/slider/slider.component.css
// module chunks = main